var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub-visual-wrap"
  }, [_c('div', {
    staticClass: "sub-visual"
  }, [_c('div', {
    staticClass: "sub-visual-tit"
  }, [_c('v-container', [_c('h2', [_vm._v(_vm._s(_vm.sh))]), _c('p', [_vm._v(_vm._s(_vm.sc))])])], 1), _c('div', {
    staticClass: "sub-visual-bg",
    style: 'background-image:url(' + _vm.bg + ');'
  }, [_c('v-container', [_vm.icon ? _c('div', {
    staticClass: "sub-visual-icon",
    style: 'background-image:url(' + _vm.icon + ');',
    attrs: {
      "data-aos": "fade-left"
    }
  }) : _vm._e()])], 1)]), _c('v-container', [_c('client-gnb', {
    attrs: {
      "className": "sub-tab-wrap",
      "tabActive": _vm.tabActive,
      "sh": _vm.sh
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }